import { css } from 'styled-components';

const commonParagraphStyles = css`
	font-style: normal;
	font-weight: 200;
	letter-spacing: -0.5px;
	margin-bottom: 5px;
	padding: 0;
`;

export default commonParagraphStyles;
